export default "__VITE_ASSET__CsTK3Keb__"